const states = {
  resultSearch: [],
  cardTracking: null
};

const getters = {
  getResult(state) {
    return state.resultSearch;
  },
  getCardTracking(state) {
    return state.cardTracking;
  }
};

const mutations = {
  setResult(state, data) {
    state.resultSearch = data;
  },
  clearResult(state) {
    state.resultSearch = [];
  },
  setCardTracking(state, data) {
    state.cardTracking = data;
  }
};

export default {
  state: states,
  getters,
  mutations
};
